import React, { useEffect } from "react";
import { Box, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";
import PaginationButtonNext from "../../input/pagination/PaginationButtonNext";
import PaginationButtonPrevious from "../../input/pagination/PaginationButtonPrevious";
import CalendarYear from "../../calendar/CalendarYear";
import ShadowBox from "../container/ShadowBox";
import SimpleBox from "../container/SimpleBox";
import PaymentSummary from "../../dataitem/PaymentSummary";

const PersonMembership = ({ payments, mt = 6 }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const years = Object.keys(payments).sort((a, b) => a - b);
    const minYear = Math.min(...years);
    const maxYear = Math.max(...years);
    const [selectedYear, setSelectedYear] = React.useState(Math.min(maxYear, dayjs().year()));

    const selectPayments = (yr) => {
        return Boolean(payments[yr]) ? Object.keys(payments[yr]).map((dt) => payments[yr][dt]) : null;
    }

    useEffect(() => {
        const yr = Math.min(maxYear, dayjs().year());
        setSelectedYear(yr);
    }, [payments]);

    const onPrevYearClick = () => {
        const yr = Math.max(minYear, selectedYear - 1);
        setSelectedYear(yr);
    }
    
    const onNextYearClick = () => {
        const yr = Math.min(maxYear, selectedYear + 1);
        setSelectedYear(yr);
    }

    const prevPayments = isMobile ? null : selectPayments(selectedYear - 1);
    const yearPaymentsArray = selectPayments(selectedYear);
    const nextPayments = isMobile ? null : selectPayments(selectedYear + 1);
    
    const checkMinYear = isMobile ? minYear : minYear + 1;
    const checkMaxYear = isMobile ? maxYear : maxYear - 1;

    const summaryInput = Object.values(payments).reduce((acc, year) => {
        const elements = Object.values(year).map(entry => entry);
        return acc.concat(elements);
    }, []);

    return (
        <ShadowBox title="Quotas Sócio" titleVariant="h3" mt={mt}>
            <PaymentSummary payments={summaryInput} paymentType="MEMBERSHIP" />
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={theme.spacing(2)}>
                <PaginationButtonPrevious onClick={onPrevYearClick} disabled={selectedYear <= checkMinYear} />
                <PaginationButtonNext onClick={onNextYearClick} disabled={selectedYear >= checkMaxYear} />
            </Box>
            <SimpleBox gap={4}>
            {
                isMobile ? null : (
                    <CalendarYear payments={prevPayments} selectedYear={selectedYear - 1} />
                )
            }
            <CalendarYear payments={yearPaymentsArray} selectedYear={selectedYear} />
            {
                isMobile ? null : (
                    <CalendarYear payments={nextPayments} selectedYear={selectedYear + 1} />
                )
            }
            </SimpleBox>
        </ShadowBox>
    )
}

export default PersonMembership;
